import {
  FeatureFlag,
  type KeyVal,
  type ProductInformation,
} from '@dealerportal/common';
import classNames from 'classnames';
import { type Dispatch, type SetStateAction, useState } from 'react';
import { SwatchZoom } from './SwatchZoom';

export const Gallery = (props: {
  productInfo: ProductInformation;
  setSpecs: Dispatch<SetStateAction<KeyVal[]>>;
}) => {
  const selectedSwatch =
    props.productInfo.swatches.find((s) => s.UPID === props.productInfo.UPID) ??
    props.productInfo.swatches[0];

  const roomscenes = [
    selectedSwatch?.imageURL,
    ...(props.productInfo?.roomscenes ?? []),
  ];

  const [mainImage, setMainImage] = useState<string>(selectedSwatch?.imageURL);
  const [initialMainImage, setInitialMainImage] = useState<string>(mainImage);

  return (
    <div>
      <div className="ui-relative">
        <SwatchZoom src={mainImage} productInfo={props.productInfo} />
        <ul className="ui-flex ui-flex-wrap ui-gap-0.5 !ui-m-0 !ui-mt-2 ui-p-0 !ui-list-none">
          {roomscenes?.length > 1 &&
            roomscenes?.map((roomscene) => (
              <li className="ui-relative" key={roomscene}>
                <img
                  onMouseLeave={() => setMainImage(initialMainImage)}
                  onMouseEnter={() => setMainImage(roomscene)}
                  onClick={() => {
                    setInitialMainImage(roomscene);
                    setMainImage(roomscene);
                  }}
                  style={{
                    height: '48px',
                    width: '48px',
                  }}
                  className={classNames(
                    'ui-p-0.5 ui-shrink-0 ui-border-solid ui-border-2 ui-border-transparent ui-rounded-md ui-gap-x-3 ui-cursor-pointer',
                    {
                      '!ui-border-[var(--cta-color,#030712)]':
                        roomscene === mainImage,
                    }
                  )}
                  src={
                    roomscene.includes('res.cloudinary.com')
                      ? roomscene.replace(
                          'https://images.floorforce.com/Textures/',
                          ''
                        )
                      : roomscene
                  }
                  alt={selectedSwatch?.colorName}
                  height={48}
                  width={48}
                />
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};
